/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { TabbedFullWidthAssetItemFragment } from "@cosmos/hygraph-schema";
import { css, cx } from "@panda/css";
import { TabbedFullWidthAssetMainStack } from "./TabbedFullWidthAsset.MainStack";

const fullwidth = css({
	height: "100%",
});

export const TabbedFullWidthAssetContent = ({
	heroAsset,
	eyebrow,
	title,
	desc,
	buttons,
	gradient,
}: TabbedFullWidthAssetItemFragment): React.JSX.Element | null => {
	if (!heroAsset && !title?.text && !desc && (!buttons || !buttons.length)) return null;

	return (
		<div className={cx(`tabbed-full-width-asset-content`, fullwidth)}>
			<TabbedFullWidthAssetMainStack
				eyebrow={eyebrow}
				title={title}
				desc={desc}
				buttons={buttons || []}
				gradient={gradient}
			/>
		</div>
	);
};
